import React from 'react'
import './style.scss'

function Loader() {
  return (
   <div id="overlay" className="d-flex justify-content-center align-items-center">
    <div>
          
    <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
  )
}

export default Loader
